export default __webpack_public_path__ + "static/media/Result.4daae79f.svg";